module.exports = __webpack_public_path__ + "media/images/icon_plus_green-481221b5ab9960f74ea3be95b9257083.svg";